import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/xlsx/xlsx-template.png'
import _imports_1 from '@/assets/xlsx/success.png'


const _hoisted_1 = { class: "process" }
const _hoisted_2 = {
  key: 0,
  class: "box-block form"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = {
  class: "value",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "value" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "value" }
const _hoisted_17 = {
  key: 1,
  class: "form-error"
}
const _hoisted_18 = { class: "error-table" }
const _hoisted_19 = {
  key: 2,
  class: "box-block enclosure"
}
const _hoisted_20 = { class: "form-right" }
const _hoisted_21 = { class: "info-enclosure-name parallel" }
const _hoisted_22 = { class: "info-right" }
const _hoisted_23 = { class: "info-name parallel" }
const _hoisted_24 = { class: "info-right" }
const _hoisted_25 = { class: "info-month parallel" }
const _hoisted_26 = { class: "info-right" }
const _hoisted_27 = { class: "info-pay-enterprise parallel" }
const _hoisted_28 = { class: "info-right" }
const _hoisted_29 = { class: "info-people-num parallel" }
const _hoisted_30 = { class: "info-right" }
const _hoisted_31 = { class: "info-total-money parallel" }
const _hoisted_32 = { class: "info-right info-right-num" }
const _hoisted_33 = {
  class: "parallel",
  style: {"justify-content":"space-between"}
}
const _hoisted_34 = {
  key: 3,
  class: "box-block result"
}
const _hoisted_35 = { class: "result-info" }
const _hoisted_36 = { class: "info-enclosure-name parallel" }
const _hoisted_37 = { class: "info-right" }
const _hoisted_38 = { class: "info-name parallel" }
const _hoisted_39 = { class: "info-right" }
const _hoisted_40 = { class: "info-month parallel" }
const _hoisted_41 = { class: "info-right" }
const _hoisted_42 = { class: "info-pay-enterprise parallel" }
const _hoisted_43 = { class: "info-right" }
const _hoisted_44 = { class: "info-people-num parallel" }
const _hoisted_45 = { class: "info-right" }
const _hoisted_46 = { class: "info-total-money parallel" }
const _hoisted_47 = { class: "info-right info-right-num" }

import alertBox from './alert-box.vue'

import { defineComponent } from 'vue'
import { getEnterpriseNameList, EnterpriseDto } from '@/api/enterprise'
import global from '@/utils/global'
import { postPayroll } from '@/api/payroll'
interface objEntDto {
    [key:string]:string | number
}
const __default__ = defineComponent({
    props: ['isType'],
    created () {
        this.getEnterpriseNameList()
        console.log(process.env.VUE_APP_BASE_URL + '/rest/pay-stub/importData2List', '路径路径')
    },
    data () {
        return {
            uploadAction: process.env.VUE_APP_BASE_URL + '/rest/pay-stub/importData2List', // 导入的路径
            whichStep: 0,
            processaName: '', // 流程名称
            enterpriseName: '', // 派遣单位名称
            enterpriseId: '', // 派遣单位Id
            totalNumber: '', // 总人数
            totalAmount: '', // 总金额
            enterpriseList: [] as EnterpriseDto[], // 派遣单位列表
            fileName: '' as string, // 附件名称
            timeMonth: '', // 选择的月
            bodyData: [] as objEntDto[], // 工资单导入返回的列表
            errorList: [] as {
                1: string
                rowNumber: number
                0: string
            }[], // 错误数据列表
            headerData: [] as { index: number;key: string; value: string; }[] // 工资单导入返回的台头
        }
    },
    methods: {
        // 查询公司下派遣单位列表
        async getEnterpriseNameList () {
            const result = await getEnterpriseNameList()
            this.enterpriseList = result.list
        },
        enterpriseDropdown (id:string) {
            this.enterpriseId = id
        },
        onUploadFileNext () {
            if (!this.timeMonth) {
                this.$message.warning('请选择年月')
                return
            }
            if (!this.processaName) {
                this.$message.warning('请输入流程名称')
                return
            }
            if (!this.enterpriseName) {
                this.$message.warning('请选择派遣单位名称')
                return
            }
            if (!this.totalNumber) {
                this.$message.warning('请导入文件')
                return
            }
            this.whichStep = 1
        },
        fileSuccess (response:{code:number, msg:string, data:{totalMoney:string, totalPerson:string, headerData:[{ index: number, key: string, value: string }], bodyData:[{ index: number; key: string; value: string; }], errorBodyData: { 1: string, rowNumber: number, 0: string }[]}}, file:{raw:{name:string}}) {
            if (response.code === 500) {
                this.$message.error(response.msg)
                return
            }
            response.data.errorBodyData.map((index:any) => {
                index[1] = index[1].replace(/(.{3})(?:\d+)(.{4})$/, '$1*********$2')
            })
            this.fileName = file.raw.name
            this.totalAmount = response.data.totalMoney
            this.totalNumber = response.data.totalPerson
            this.errorList = response.data.errorBodyData
            this.bodyData = response.data.bodyData
            this.headerData = response.data.headerData
        },
        fileEerror () {
            this.$message.error('文件上传失败')
        },
        async onAddBatchPay () {
            await postPayroll({
                name: this.processaName,
                totalMoney: this.totalAmount,
                peopleNum: this.totalNumber,
                serveCompanyId: this.enterpriseId,
                serveCompanyName: this.enterpriseName,
                month: this.timeMonth,
                bodyInfo: this.bodyData,
                headerList: this.headerData
            })
            this.whichStep += 1
        },
        onCloseEject () {
            this.$emit('close')
            this.$emit('complete')
        }
    }
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'batch-payroll',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(alertBox, {
    "data-title": "发送薪资单",
    isCloseType: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.whichStep === 0 ? 'active' : '','process-box'])
        }, _cache[9] || (_cache[9] = [
          _createElementVNode("div", { class: "no" }, [
            _createElementVNode("i", { class: "el-icon el-icon-check" })
          ], -1),
          _createElementVNode("span", null, "上传文件", -1)
        ]), 2),
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "arrow" }, [
          _createElementVNode("i", { class: "el-icon el-icon-arrow-right" })
        ], -1)),
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.whichStep === 1 ? 'active' : '','process-box'])
        }, _cache[10] || (_cache[10] = [
          _createElementVNode("div", { class: "no" }, " 2 ", -1),
          _createElementVNode("span", null, "确认信息", -1)
        ]), 2),
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "arrow" }, [
          _createElementVNode("i", { class: "el-icon el-icon-arrow-right" })
        ], -1)),
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.whichStep === 2 ? 'active' : '','process-box'])
        }, _cache[11] || (_cache[11] = [
          _createElementVNode("div", { class: "no" }, " 3 ", -1),
          _createElementVNode("span", null, "查看结果", -1)
        ]), 2)
      ]),
      (_ctx.whichStep === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_el_upload, {
              class: "upload-demo",
              drag: "",
              action: _ctx.uploadAction,
              headers: {Authorization:'Bearer' + ' ' + _unref(global).token},
              accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              "on-success": _ctx.fileSuccess,
              "on-error": _ctx.fileEerror,
              "show-file-list": false
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "key" }, [
                      _createElementVNode("span", { class: "important" }, "*"),
                      _createElementVNode("span", null, "发薪数据")
                    ], -1)),
                    _createElementVNode("div", _hoisted_5, [
                      _cache[14] || (_cache[14] = _createElementVNode("button", { class: "btn import-btn" }, [
                        _createElementVNode("i", { class: "el-icon el-icon-upload2" }),
                        _createTextVNode("导入 ")
                      ], -1)),
                      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "tipsText" }, " 或拖拽至此处 ", -1)),
                      _createElementVNode("a", {
                        class: "down-templete",
                        href: "https://bullet001.51zidan.com/file/template/template_stub.xlsx",
                        onClick: _withModifiers(()=>{return}, ["stop"])
                      }, "模板下载")
                    ])
                  ]),
                  _cache[17] || (_cache[17] = _createElementVNode("div", null, null, -1))
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "key" }, [
                      _createElementVNode("span", { class: "important" }, "*"),
                      _createElementVNode("span", null, "名称：")
                    ], -1)),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_el_input, {
                        onClick: _withModifiers(()=>{return 0}, ["stop"]),
                        placeholder: "请输入名称",
                        name: "processaName",
                        modelValue: _ctx.processaName,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.processaName) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_el_form, {
                      "label-position": "left",
                      "label-width": "100px"
                    }, {
                      default: _withCtx(() => [
                        _cache[19] || (_cache[19] = _createElementVNode("span", { class: "important" }, "*", -1)),
                        _createVNode(_component_el_form_item, { label: "派遣单位名称" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.enterpriseName,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.enterpriseName) = $event)),
                              filterable: "",
                              placeholder: "请选择派遣单位"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enterpriseList, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    label: item.serveCompanyName,
                                    value: item.serveCompanyName,
                                    key: index,
                                    onClick: ($event: any) => (_ctx.enterpriseDropdown(item.id))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.serveCompanyName), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["label", "value", "onClick"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "key" }, [
                      _createElementVNode("span", { class: "important" }, "*"),
                      _createElementVNode("span", null, "年月")
                    ], -1)),
                    _createElementVNode("div", {
                      class: "value",
                      onClick: _withModifiers(()=>{return 0}, ["stop"])
                    }, [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.timeMonth,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.timeMonth) = $event)),
                        type: "month",
                        format: "YYYY-MM",
                        "value-format": "YYYY-MM",
                        placeholder: "请选择月份",
                        style: {"width":"240px"},
                        onClick: ()=>{return}
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "key" }, [
                      _createElementVNode("span", { class: "important" }, "*"),
                      _createElementVNode("span", null, "总金额")
                    ], -1)),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_el_input, {
                        placeholder: "上传表单后自动填充",
                        disabled: "",
                        name: "totalAmount",
                        modelValue: _ctx.totalAmount,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.totalAmount) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "key" }, [
                      _createElementVNode("span", { class: "important" }, "*"),
                      _createElementVNode("span", null, "总人数")
                    ], -1)),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_el_input, {
                        placeholder: "上传表单后自动填充",
                        disabled: "",
                        name: "totalNumber",
                        modelValue: _ctx.totalNumber,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.totalNumber) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                (!_ctx.errorList.length)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn mini-btn",
                      onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onUploadFileNext && _ctx.onUploadFileNext(...args)), ["stop"]))
                    }, "下一步"))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["action", "headers", "on-success", "on-error"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.errorList.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createVNode(_component_el_alert, {
              title: `本次上传文件共发现${_ctx.errorList.length}处错误,请修改后重新上传`,
              type: "error",
              center: "",
              "show-icon": ""
            }, null, 8, ["title"]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_el_table, {
                data: _ctx.errorList,
                "header-row-style": { color: 'black',},
                "row-style": { border:'none'}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "行号",
                    formatter: row => (row.rowNumber),
                    width: "100px"
                  }, null, 8, ["formatter"]),
                  _createVNode(_component_el_table_column, {
                    prop: "0",
                    label: "姓名",
                    width: "100px"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "1",
                    label: "身份证号",
                    width: "200px"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "errorDetail",
                    label: "错误提示"
                  })
                ]),
                _: 1
              }, 8, ["data"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.whichStep === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _cache[30] || (_cache[30] = _createElementVNode("div", { class: "form-left" }, [
              _createElementVNode("div", { class: "info-title" }, " 发薪数据单 "),
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  src: _imports_0,
                  class: "xlsx-img"
                })
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_20, [
              _cache[29] || (_cache[29] = _createElementVNode("div", { class: "info-title" }, " 确认信息 ", -1)),
              _createElementVNode("div", _hoisted_21, [
                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "info-left" }, " 附件名称： ", -1)),
                _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.fileName), 1)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "info-left" }, " 名称： ", -1)),
                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.processaName), 1)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "info-left" }, " 年月： ", -1)),
                _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.timeMonth), 1)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _cache[26] || (_cache[26] = _createElementVNode("div", { class: "info-left" }, " 发薪派遣单位： ", -1)),
                _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.enterpriseName), 1)
              ]),
              _createElementVNode("div", _hoisted_29, [
                _cache[27] || (_cache[27] = _createElementVNode("div", { class: "info-left" }, " 总人数： ", -1)),
                _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.totalNumber) + "人 ", 1)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _cache[28] || (_cache[28] = _createElementVNode("div", { class: "info-left" }, " 总金额： ", -1)),
                _createElementVNode("div", _hoisted_32, " ￥" + _toDisplayString(_ctx.totalAmount), 1)
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("button", {
                  class: "btn-white",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.whichStep-=1))
                }, "重新选择"),
                _createElementVNode("button", {
                  class: "btn",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onAddBatchPay && _ctx.onAddBatchPay(...args)))
                }, "确认添加")
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.whichStep === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            _cache[37] || (_cache[37] = _createElementVNode("img", {
              src: _imports_1,
              alt: "",
              class: "result-success"
            }, null, -1)),
            _cache[38] || (_cache[38] = _createElementVNode("div", { class: "result-title" }, " 发放成功 ", -1)),
            _createElementVNode("button", {
              class: "btn",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onCloseEject && _ctx.onCloseEject(...args)))
            }, "返回列表"),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _cache[31] || (_cache[31] = _createElementVNode("div", { class: "info-left" }, " 附件名称： ", -1)),
                _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.fileName), 1)
              ]),
              _createElementVNode("div", _hoisted_38, [
                _cache[32] || (_cache[32] = _createElementVNode("div", { class: "info-left" }, " 名称： ", -1)),
                _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.processaName), 1)
              ]),
              _createElementVNode("div", _hoisted_40, [
                _cache[33] || (_cache[33] = _createElementVNode("div", { class: "info-left" }, " 年月： ", -1)),
                _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.timeMonth), 1)
              ]),
              _createElementVNode("div", _hoisted_42, [
                _cache[34] || (_cache[34] = _createElementVNode("div", { class: "info-left" }, " 发薪派遣单位： ", -1)),
                _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.enterpriseName), 1)
              ]),
              _createElementVNode("div", _hoisted_44, [
                _cache[35] || (_cache[35] = _createElementVNode("div", { class: "info-left" }, " 总人数： ", -1)),
                _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.totalNumber) + "人 ", 1)
              ]),
              _createElementVNode("div", _hoisted_46, [
                _cache[36] || (_cache[36] = _createElementVNode("div", { class: "info-left" }, " 总金额： ", -1)),
                _createElementVNode("div", _hoisted_47, " ￥" + _toDisplayString(_ctx.totalAmount), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})